import React from "react";
import {
    List,
    Datagrid,
    TextField,
    BooleanField,
    EditButton,
    Create,
    Edit,
    SimpleForm,
    TextInput,
    NumberInput,
    BooleanInput,
    required,
} from "react-admin";

export const TariffPlanList = () => (
    <List>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" label="Название" />
            <TextField source="bin_limit" label="Лимит БИНов" />
            <BooleanField source="is_active" label="Активен" />
            <BooleanField source="is_auditor" label="Аудитор" />
            <EditButton />
        </Datagrid>
    </List>
);

export const TariffPlanCreate = () => (
    <Create>
        <SimpleForm>
            <TextInput source="name" label="Название" validate={[required()]} />
            <NumberInput source="bin_limit" label="Лимит БИНов" />
            <BooleanInput source="is_active" label="Активен" defaultValue={true} />
            <BooleanInput source="is_auditor" label="Аудитор" />
        </SimpleForm>
    </Create>
);

export const TariffPlanEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="name" label="Название" validate={[required()]} />
            <NumberInput source="bin_limit" label="Лимит БИНов" />
            <BooleanInput source="is_active" label="Активен" />
            <BooleanInput source="is_auditor" label="Аудитор" />
        </SimpleForm>
    </Edit>
);